import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import InfoMessage from '@swf/components/InfoMessage/InfoMessage';
import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import { StatusCode } from '@swf/core/enums/statusCode';

import { ExclusionTime } from '../../../shared/definitions';
import AccountDate from '../../AccountDate/AccountDate';
import { ExclusionType } from '../../definitions';
import { ExclusionResponseWithdrawalMessage } from '../ExclusionResponseWithdrawalMessage/ExclusionResponseWithdrawalMessage';

import {
  TXTWCL_This_means_you_wonXt_be_able_t_ELL_5,
  TXTWCL_WeXll_automatically_reopen_you_ELL,
  TXTWCL_WeXll_automatically_reopen_you_ELL_1,
  TXTWCL_We_canXt_process_your_request__ELL_1,
  TXTWCL_YouXll_be_able_to_request_to_r_ELL,
  TXTWCL_YouXre_taking_a_break
} from './ExclusionResponseUSMI.messages.json';

interface Props {
  error?: boolean;
  statusCode?: StatusCode;
  timeUntil?: number | string;
  daysRequested?: number;
  exclusionType?: ExclusionType;
}

const ExclusionResponseUSMI: React.FC<Props> = ({
  error,
  statusCode,
  timeUntil,
  daysRequested,
  exclusionType
}) => {
  const isSuccessConfirmation = statusCode === StatusCode.USER_SELF_EXCLUDED;
  const isTakingABreak = exclusionType === ExclusionType.Break;

  const currentDate = new Date();
  let endDate;
  if (timeUntil) {
    endDate = new Date(timeUntil);
  } else {
    const daysToAdd =
      daysRequested && daysRequested > ExclusionTime.OneDay
        ? ExclusionTime.ThirtyDays
        : ExclusionTime.OneDay;
    endDate = currentDate.setDate(currentDate.getDate() + daysToAdd);
  }
  const formattedEndDate = (
    <b>
      <AccountDate date={endDate} />
    </b>
  );

  switch (true) {
    case error:
      return (
        <InfoMessage type="error">
          <Translation {...TXTWCL_We_canXt_process_your_request__ELL_1} />
        </InfoMessage>
      );
    case isSuccessConfirmation:
      return (
        <InfoMessage type="confirmation" messageTitle={TXTWCL_YouXre_taking_a_break}>
          <div>
            {isTakingABreak ? (
              <Translation
                {...TXTWCL_WeXll_automatically_reopen_you_ELL_1}
                values={{
                  0: formattedEndDate
                }}
              />
            ) : (
              <>
                <Translation
                  {...TXTWCL_This_means_you_wonXt_be_able_t_ELL_5}
                  values={{ 0: formattedEndDate }}
                />{' '}
                <Translation
                  {...TXTWCL_YouXll_be_able_to_request_to_r_ELL}
                  values={{
                    a: (msg: React.ReactNode) => (
                      <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
                    )
                  }}
                />
              </>
            )}{' '}
            <ExclusionResponseWithdrawalMessage />
          </div>
        </InfoMessage>
      );
    default:
      return (
        <div>
          <Translation
            {...TXTWCL_This_means_you_wonXt_be_able_t_ELL_5}
            values={{ 0: formattedEndDate }}
          />{' '}
          {isTakingABreak ? (
            <Translation {...TXTWCL_WeXll_automatically_reopen_you_ELL} />
          ) : (
            <Translation
              {...TXTWCL_YouXll_be_able_to_request_to_r_ELL}
              values={{
                a: (msg: React.ReactNode) => (
                  <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
                )
              }}
            />
          )}{' '}
          <ExclusionResponseWithdrawalMessage useLongMessage />
        </div>
      );
  }
};

export default ExclusionResponseUSMI;
